// extracted by mini-css-extract-plugin
export default {"switchBtn":"switch_switchBtn__TY24N","active":"switch_active__9Dyb1"};